export default "__VITE_ASSET__CEpHcUob__"